import React, { FunctionComponent } from 'react';

import { css } from '@emotion/core';
import { Link } from '@rebass/emotion';

interface LinkProps {
  text: string;
  href: string;
  color?: string;
  inNewTab: boolean;
}

const StyledLink: FunctionComponent<LinkProps> = ({ text, href, color, inNewTab }) => {
  return (
    <Link
      css={css`
        text-decoration: none;
        color: ${color};
        cursor: pointer;
        margin-left: 1em;
        margin-right: 1em;
        font-weight: bold;
      `}
      fontSize={[1, 1, 2]}
      href={href}
      target={inNewTab ? '_blank' : ''}
    >
      {text}
    </Link>
  );
};

export default StyledLink;
